import { useQuery } from '@tanstack/react-query';
import { fetchLocalGenres } from './fetchLocalGenres';
import { GlobalReactQueryOptions } from '../../../../config';

export const LOCAL_CONTENT_GENRES_KEY = 'localContentGenres';

interface LocalContentGenreParams {
    fiction?: boolean;
    category?: string;
    searchQuery: string;
    enabled: boolean;
}
export const useLocalContentGenres = ({ fiction, category, searchQuery, enabled }: LocalContentGenreParams) => {
    return useQuery(
        [LOCAL_CONTENT_GENRES_KEY, { fiction, category, searchQuery }],
        () => fetchLocalGenres(fiction, category, searchQuery),
        {
            ...GlobalReactQueryOptions,
            enabled
        }
    );
};
